import ImageSlider from "./ImageSlider";
import { pcafSlides } from "../data/pcaf-slides";

export default function PcafSlider(props) {
  const { slides, ...rest } = props || {};
  return (
    <ImageSlider
      slides={Array.isArray(slides) && slides.length > 0 ? slides : pcafSlides}
      containerClass="max-w-6xl mx-auto"
      defaultLayout="split"
      {...rest}
    />
  );
}
